export default "__VITE_ASSET__CpT_JEFz__"